import React from 'react';
import ReactArcText from "react-arc-text-fix";
import { Link as RouterLink } from "react-router-dom";
import { Box } from '@material-ui/core';

import { AppButton } from '../components/InputComponents';

import useStyles from "./Home.style";

import logo from "../../../images/logo_full.png";

const Home = () => {
	const classes = useStyles();

	return (
		<Box className={classes.root}>
			<Box className={classes.logoSection}>
				<Box className={classes.curvedTitle}>
					<ReactArcText text="Envision your reproductive life journey" arc={220} />
				</Box>
				<Box className={classes.logo}>
					<img src={logo} alt="logo" />
				</Box>
				<Box className={classes.logoCaption}>
					REPRODUCTIVE LIFE IMAGINED
				</Box>
			</Box>
			<Box className={classes.footer}>
				<AppButton
					variant="contained"
					color="secondary"
					fullWidth
					size="large"
					component={RouterLink}
					to="/app/intro"
				>
					Get Started
				</AppButton>
				<div className={classes.versioNumber}>v1.1</div>
			</Box>
		</Box>
	);
};

export default Home;
